module.exports = __webpack_public_path__ + "img/4.982e1702.png";